import { Directive, HostListener, ElementRef, Inject, DOCUMENT } from '@angular/core';


@Directive({
    selector: '[copDropdown]',
    standalone: false
})

export class DropdownDirective {

  constructor(@Inject(DOCUMENT) private document: any, private el: ElementRef) {}

  @HostListener('click', ['$event'])
  toggle($event: any) {
    $event.stopPropagation();
    if (this.el.nativeElement.children && this.el.nativeElement.children.length && this.el.nativeElement.children[1] && this.el.nativeElement.children[1].classList.contains('open')) {
      this.el.nativeElement.children[1].classList.remove('open');
      let arrowIcons = this.document.querySelectorAll('.rotate')
      arrowIcons.forEach(function (icon) {
        icon.classList.remove('rotate')
      });
      this.el.nativeElement.classList.remove('active');
    } else {
      let dropdowns = document.querySelectorAll('.menu-dropdown,.user-dropdown')
      for (let i = 0; i < dropdowns.length; i++) {
        dropdowns[i].classList.remove('open');
        let arrowIcons = this.document.querySelectorAll('.rotate')
        arrowIcons.forEach(function (icon) {
          icon.classList.remove('rotate');
        });
        this.el.nativeElement.classList.remove('active');
      }

      let subdropdowns = this.el.nativeElement.querySelectorAll('.submenu');
      for (let i = 0; i < subdropdowns.length; i++) {
        subdropdowns[i].classList.remove('open');
        let arrowIcons = this.document.querySelectorAll('.rotate')
        arrowIcons.forEach(function (icon) {
          icon.classList.remove('rotate');
        });
        this.el.nativeElement.classList.remove('active');
      }
      if (this.el.nativeElement.children && this.el.nativeElement.children.length && this.el.nativeElement.children[1]) {
        this.el.nativeElement.children[1].classList.add('open');
        this.el.nativeElement.classList.add('active');
      }
      try {
        if (this.el.nativeElement.children && this.el.nativeElement.children.length && this.el.nativeElement.children[0]
          && this.el.nativeElement.children[0].children && this.el.nativeElement.children[0].children.length && this.el.nativeElement.children[0].children[0]
          && this.el.nativeElement.children[0].children[0].children && this.el.nativeElement.children[0].children[0].children.length && this.el.nativeElement.children[0].children[0].children[0]
        ) {
          if (this.el.nativeElement.children[0].children[0].children[0].classList.contains('icon-arrow-down')) {
            this.el.nativeElement.children[0].children[0].children[0].classList.add('rotate');
          }
        }
      } catch(e) {
        console.log("dropdown",e);
      }
    }
  }
}


@Directive({
    selector: '[copSubDropdown]',
    standalone: false
})

export class SubDropdownDirective {

  constructor(@Inject(DOCUMENT) private document: any, private el: ElementRef) {}

  @HostListener('click', ['$event'])
  toggle($event: any) {
    $event.stopPropagation();
    if (this.el.nativeElement.children && this.el.nativeElement.children.length && this.el.nativeElement.children[1] && this.el.nativeElement.children[1].classList.contains('open')) {
      let arrowIcons = this.document.querySelectorAll('.rotateSub')
      arrowIcons.forEach(function (icon) {
        icon.classList.remove('rotateSub');
      });
      this.el.nativeElement.classList.remove('active');
    } else {
      let sbdropdowns = this.document.querySelectorAll('.submenu');

      for (let i = 0; i < sbdropdowns.length; i++) {
        sbdropdowns[i].classList.remove('open');
      }

      this.el.nativeElement.classList.remove('active');
      if (this.el.nativeElement.children && this.el.nativeElement.children.length && this.el.nativeElement.children[1]) {
        this.el.nativeElement.children[1].classList.add('open');
        this.el.nativeElement.classList.add('active');
      }
    }
  }
}


@Directive({
    selector: '[copprofDropdown]',
    standalone: false
})

export class ProfileDropdownDirective {

  constructor(@Inject(DOCUMENT) private document: any, private el: ElementRef) {}

  @HostListener('click', ['$event'])
  toggle($event: any) {
    $event.stopPropagation();
    if (this.el.nativeElement.children[1] && this.el.nativeElement.children[1].classList.contains('open')) {
      this.el.nativeElement.children[1].classList.remove('open');
      this.el.nativeElement.classList.remove('active');
    } else {
      let sbdropdowns = this.document.querySelectorAll('.menu-dropdown,.user-dropdown');

      for (let i = 0; i < sbdropdowns.length; i++) {
        sbdropdowns[i].classList.remove('open');
      }
      this.el.nativeElement.classList.remove('active');
      if (this.el.nativeElement.children[1]) {
        this.el.nativeElement.children[1].classList.add('open');
        this.el.nativeElement.classList.add('active');
      }
    }
  }
}
